import ColorX from "./ColorX";

class BorderX {

  /**
   * for CSS background-image
   * @param {Object} param0 
   * @param {Number} [param0.strokeWidth=4] 
   * @param {Number[]} [param0.dashArray=[25]] 
   * @param {String} [param0.color=ColorX.CSS("lightGrey")] 
   * @param {String} [param0.lineCap="square"] 
   * @param {Number} [param0.dashOffset=0] 
   * @param {Number} [param0.borderRadius=0] 
   */
  static Render({
    strokeWidth = 4,
    dashArray = [25],
    color = ColorX.CSS("lightGrey"),
    lineCap = "square",
    dashOffset = 0,
    borderRadius = 0
  }){
    let rgba = ColorX.ExtractCSS(color);
    let hex = ColorX.toHex(rgba.r, rgba.g, rgba.b, rgba.a).replace("#","");

    return `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='${borderRadius}' ry='${borderRadius}' stroke='%23${hex}' stroke-width='${strokeWidth ?? 4}' stroke-dasharray='${dashArray.join("%2c ")}' stroke-dashoffset='${dashOffset}' stroke-linecap='${lineCap}'/%3e%3c/svg%3e")`;
  }

}

export default BorderX;